import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  DevolucionCumplimientoRepository
} from 'src/app/domain/service/devolucion-cumplimiento/devolucion-cumplimiento-repository';
import {
  DevolucionCumplimiento,
  DevolucionCumplimientoFiltro,
  DevolucionCumplimientoResultado,
  AnularCumplimientosRequest
} from 'src/app/domain/model/devolucion-cumplimiento/devolucion-cumplimiento';

/**
 * Adaptador HTTP: HttpDevolucionCumplimientoRepository
 *
 * Backend: /api/servicios/devolucion-cumplimientos
 * Legacy: DevolucionCumplimientosFacade.java
 */
@Injectable({ providedIn: 'root' })
export class HttpDevolucionCumplimientoRepository implements DevolucionCumplimientoRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/devolucion-cumplimientos`;

  async listarCumplimientos(
    filtro: DevolucionCumplimientoFiltro,
    page: number,
    size: number
  ): Promise<DevolucionCumplimiento[]> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    if (filtro.ivacumplimientos) {
      params = params.set('ivacumplimientos', filtro.ivacumplimientos);
    }
    if (filtro.ivaorden) {
      params = params.set('ivaorden', filtro.ivaorden);
    }
    if (filtro.ivaprog) {
      params = params.set('ivaprog', filtro.ivaprog);
    }
    if (filtro.inuoficina) {
      params = params.set('inuoficina', filtro.inuoficina.toString());
    }
    if (filtro.inubeneficiario) {
      params = params.set('inubeneficiario', filtro.inubeneficiario.toString());
    }
    if (filtro.inuasesor) {
      params = params.set('inuasesor', filtro.inuasesor.toString());
    }

    return firstValueFrom(
      this.http.get<DevolucionCumplimiento[]>(this.baseUrl, { params })
    );
  }

  async anularCumplimientos(
    request: AnularCumplimientosRequest
  ): Promise<DevolucionCumplimientoResultado> {
    return firstValueFrom(
      this.http.post<DevolucionCumplimientoResultado>(`${this.baseUrl}/anular`, request)
    );
  }
}
